import {createSlice} from "@reduxjs/toolkit";

const initialLinksState = {
  listLoading: false,
  summaryLoading: false,
  balanceSummary: null,
  totalCount: 0,
  salesList: null,
  lastError: null,
};

export const callTypes = {
  summary: "summary",
  list: "list",
};

export const balancesSlice = createSlice({
  name: "balances",
  initialState: initialLinksState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.summaryLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.summaryLoading = true;
      }
    },
    summaryFetched: (state, action) => {
      const {summary} = action.payload;
      state.summaryLoading = false;
      state.balanceSummary = summary;
      state.error = null;
    },
    salesListFetched: (state, action) => {
      const {totalCount, salesList} = action.payload;
      state.listLoading = false;
      state.salesList = salesList;
      state.totalCount = totalCount;
      state.error = null;
    },
  }
});
